import { Button } from '@sentinel/ui';
import { QueryState } from '@sentinel/web-core';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ModulesPanel } from './ModulesPanel';
import { usageOf } from './organization-state';
import { PlanLimitsPanel } from './PlanLimitsPanel';
import { StatusPanel } from './StatusPanel';
import { useOrganization } from './use-organization';

/** One organization: its modules, contract and state, and what it uses of the contract. */
export function OrganizationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { organizationId = '' } = useParams({ strict: false });
  const state = useOrganization(organizationId);

  return (
    <QueryState query={state.organization}>
      {(organization) => (
        <div className="stack">
          <header style={{ display: 'flex', gap: 16, alignItems: 'baseline', flexWrap: 'wrap' }}>
            <h1 className="h1">{organization.name}</h1>
            <span className="note mono">{organization.slug}</span>
            <span className="note">
              {t('console.organization.usage', {
                users: usageOf(organization.usage.users, organization.limits.maxUsers),
                missions: usageOf(
                  organization.usage.activeMissions,
                  organization.limits.maxActiveMissions,
                ),
                devices: usageOf(organization.usage.devices, organization.limits.maxDevices),
                storage: usageOf(organization.usage.storageMb, organization.limits.storageMb),
              })}
            </span>
            <Button size="sm" onClick={() => void navigate({ to: '/' })}>
              {t('console.organization.back')}
            </Button>
          </header>
          <div className="split2">
            <ModulesPanel modules={state.modules} setModule={state.setModule} />
            <div className="stack">
              <PlanLimitsPanel
                key={`${organization.planKey ?? ''}-${JSON.stringify(organization.limits)}`}
                organization={organization}
                setPlan={state.setPlan}
                setLimits={state.setLimits}
              />
              <StatusPanel organization={organization} changeStatus={state.changeStatus} />
            </div>
          </div>
        </div>
      )}
    </QueryState>
  );
}
